module.exports = __webpack_public_path__ + "img/rousseau.221b2b36.jpg";